module.exports = __webpack_public_path__ + "static/img/default_clazz.81d757d0.jpg";